import { jobSlugFamilySql } from './job-merge-sql.mjs';

// Imported stages at or beyond a real CV submission count alongside native sends.
// Owner clarification, 1 October 2026: both Assigned labels mean a real send.
export const CV_SEND_STAGE_LABELS = ['CV Sent', 'Assigned', 'Assigned to Job'];
export const CV_HISTORY_LABELS = [...CV_SEND_STAGE_LABELS, '1st IV', '2nd IV', '3rd IV', 'Offer', 'WFB', 'Contract', 'Placed'];
// Preserve the existing broader workflow/trend treatment of Did Not Join.
export const hasImportedProcessStage = (label) => CV_HISTORY_LABELS.includes(label);
export const CV_SENT_LIKE_LABELS = [...CV_HISTORY_LABELS, 'Did Not Join'];

// De spiegel rcrm_job_assignments blijft bij een samenvoeging op de verliezer staan:
// de assignment-tak leest daarom de familie van de job (lib/job-merge.mjs). De
// cv_sends zelf verhuisden naar de winnaar. Een deal wijst al naar de winnaar.
export async function hasCvSendEvidence(query, candidateSlug, jobSlug) {
  if (!candidateSlug || !jobSlug) return false;
  const { rows } = await query(`SELECT EXISTS(SELECT 1 FROM cv_sends WHERE candidate_slug=$1 AND job_slug=$2 AND status='sent')
    OR EXISTS(SELECT 1 FROM rcrm_job_assignments WHERE candidate_slug=$1 AND job_slug IN ${jobSlugFamilySql('$2::text')} AND status_label=ANY($3)) AS present`,
  [String(candidateSlug), String(jobSlug), CV_SENT_LIKE_LABELS]);
  return rows[0]?.present === true;
}
